module.exports = __webpack_public_path__ + "media/images/product_lines/travel/h1-c5f62a7111780328a42977ec0a357524.svg";